import { render } from "./Authentication.vue?vue&type=template&id=1efe7bfd&scoped=true"
import script from "./Authentication.vue?vue&type=script&lang=js"
export * from "./Authentication.vue?vue&type=script&lang=js"

import "./Authentication.vue?vue&type=style&index=0&id=1efe7bfd&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-1efe7bfd"

export default script